import { Injectable } from '@angular/core';
import { CoolSessionStorage } from '@angular-cool/storage';
import { bcSessionKeys } from '../common/constants/session-keys';

@Injectable({
  providedIn: 'root'
})
export class AutoSavePersistService {
  static readonly storageMasterKey = bcSessionKeys.storage.drafts;

  constructor(private readonly coolSessionStorage: CoolSessionStorage) {
  }

  load(storageKey: string): Object | undefined {
    const storageContent = this.getSafeStorageObject();
    return storageContent.hasOwnProperty(storageKey) ? storageContent[storageKey] : undefined;
  }

  save(storageKey: string, model: Object): void {
    this.persist(storageKey, model);
  }

  clear(storageKey: string): void {
    this.persist(storageKey, undefined);
  }

  private persist(storageKey: string, model: Object): void {
    const drafts = {
      ...this.getSafeStorageObject(),
      [storageKey]: model
    };

    this.coolSessionStorage.setObject(AutoSavePersistService.storageMasterKey, drafts);
  }

  private getSafeStorageObject(): Object {
    return this.coolSessionStorage.tryGetObject(AutoSavePersistService.storageMasterKey) || {};
  }
}
